import styled from 'styled-components';
import Icon from '../../../../_shared/components/Icon';
import Label from '../../../../_shared/components/Label';

export const FilterContainer = styled.div`
  background-color: ${({ theme }) => theme.COLORS.BASE};
  display: flex;
  flex-direction: column;
  z-index: 100;

  @media only screen and (max-width: ${({ theme }) => theme.BP.VDP_MOBILE_WH}) {
    padding: 12px 36px 30px;
    max-height: ${props => (props.hasTradeInVehicle ? '289px' : '319px')};
    width: 100%;
    position: fixed;
    bottom: -211px;
  }

  @media only screen and (min-width: ${({ theme }) =>
      theme.BP.VDP_DESKTOP_WL}) {
    width: 321px;
    max-height: 442px;
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.2);
    padding: 30px 30px 24px 31px;
    position: absolute;
    top: 18px;
    left: 18px;
  }
`;

export const StyledSection = styled.div`
  margin-bottom: 18px;
`;

export const FilterHeader = styled.div`
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  padding-bottom: 21px;

  @media only screen and (max-width: ${({ theme }) => theme.BP.VDP_MOBILE_WH}) {
    text-align: center;
    margin-top: 17px;
  }
`;

export const FilterHeaderIcon = styled(Icon).attrs({
  icon: 'TR5-Filter_map'
})`
  width: 30px;
  height: 30px;
  margin-right: 12px;
`;

export const StyledLabel = styled(Label)`
  margin-bottom: 6px;
`;

export const StyledInfo = styled.a`
  display: inline-block;
  margin-left: auto;
  text-decoration: underline;
  color: ${({ theme }) => theme.COLORS.TERTIARY};
  cursor: pointer;
`;

export const FilterPicker = styled.div`
  border: 1px solid ${({ theme }) => theme.COLORS.NEUTRAL_10};
  border-radius: 3px;
  background-color: ${({ theme }) => theme.COLORS.BASE};
  min-height: 36px;
  display: flex;
  justify-content: space-between;

  & > button {
    border-right: 1px solid ${({ theme }) => theme.COLORS.NEUTRAL_10};
  }

  &:last-child {
    border-right: 0;
  }
`;

export const FilterHandle = styled.div`
  margin: 0 auto;
  height: 4px;
  width: 59px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.COLORS.SILVER};
  position: inherit;
`;

export const NoTradeInHeader = styled.div`
  font-size: ${({ theme }) => theme.FONT_SIZES.XLARGE};
  padding-bottom: 9px;
`;
